 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import TEXTTITLE from '@/components/Text/title'
 import TEXTFRONT1 from '@/components/Text/front1'
 import TEXTTOC from '@/components/Text/toc'
 import TEXTFWD from '@/components/Text/fwd'
 import TEXTINTRO from '@/components/Text/intro'
 import TEXTPART1 from '@/components/Text/part1'
 import TEXTCHAPTER1 from '@/components/Text/chapter1'
 import TEXTCHAPTER2 from '@/components/Text/chapter2'
 import TEXTCHAPTER3 from '@/components/Text/chapter3'
 import TEXTCHAPTER4 from '@/components/Text/chapter4'
 import TEXTCHAPTER5 from '@/components/Text/chapter5'
 import TEXTCHAPTER6 from '@/components/Text/chapter6'
 import TEXTCHAPTER7 from '@/components/Text/chapter7'
 import TEXTCHAPTER8 from '@/components/Text/chapter8'
 import TEXTCHAPTER9 from '@/components/Text/chapter9'
 import TEXTCHAPTER10 from '@/components/Text/chapter10'
 import TEXTCHAPTER11 from '@/components/Text/chapter11'
 import TEXTCHAPTER12 from '@/components/Text/chapter12'
 import TEXTCHAPTER13 from '@/components/Text/chapter13'
 import TEXTPART2 from '@/components/Text/part2'
 import TEXTCHAPTER14 from '@/components/Text/chapter14'
 import TEXTCHAPTER15 from '@/components/Text/chapter15'
 import TEXTCHAPTER16 from '@/components/Text/chapter16'
 import TEXTCHAPTER17 from '@/components/Text/chapter17'
 import TEXTCHAPTER18 from '@/components/Text/chapter18'
 import TEXTEPI from '@/components/Text/epi'
 import TEXTBIB from '@/components/Text/bib'
 import TEXTABT from '@/components/Text/abt'
 import TEXTMOREIVP from '@/components/Text/moreIVP'
 import TEXTCOPY from '@/components/Text/copy'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/toc",
 			"name" : "Text/toc",
 			"component" : TEXTTOC
 		},
 		{
 			"path" : "/Text/fwd",
 			"name" : "Text/fwd",
 			"component" : TEXTFWD
 		},
 		{
 			"path" : "/Text/intro",
 			"name" : "Text/intro",
 			"component" : TEXTINTRO
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js